import styled from 'styled-components';
import { Typ20, Typ31 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: transparent;
`;

export const Title = styled(Typ31)`
  text-overflow: ellipsis;
  line-height: 22px;
  color: ${props => (props.theme === 'dark' ? '#fff' : '#263238')};
`;

export const Label = styled(Lab010)`
  padding-right: 8px;
`;

export const Description = styled(Typ20)`
  color: ${props =>
    props.theme === 'dark' ? 'rgba(255,255,255,0.4)' : '#546E7A'};
`;
